import { render, staticRenderFns } from "./BookAppealDateAppLeaveGrantedPg.vue?vue&type=template&id=20997969&scoped=true"
import script from "./BookAppealDateAppLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./BookAppealDateAppLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20997969",
  null
  
)

export default component.exports